<template>
  <div class="row justify-content-center" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="200">
    <div class="col-12 text-center">
      <button class="btn" v-for="locale in locales" :key="locale" @click="$emit('update', { locale: locale.replace('us', 'en') })">
        <country-flag :country="locale" size="big"  />
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '@/admins/api'
import Spinner from '@/shared/spinner.vue'
import CountryFlag from 'vue-country-flag'

export default {
  components: {
    CountryFlag,
    Spinner
  },
  props: {
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      locales: ['us', 'es']
    }
  }
}
</script>
